import i18n, { currentLanguage } from ".";
import { ServerMessage, serverMessage } from "./serverMessages";
import { RoleConfig, SectionNameOverrides } from "../DTOs/Settings/RoleConfigDto";
import { SECTION_NAMES, SectionKey, VIEW_NAMES, ViewKey } from "../utilities/helpers/pageVocabulary.generated";

export const viewName = (view: ViewKey) => i18n.t(`views.${view}`, { ns: "nav", defaultValue: VIEW_NAMES[view] });

export const sectionName = (section: SectionKey) =>
  i18n.t(`sections.${section}`, { ns: "nav", defaultValue: SECTION_NAMES[section] });

export type { SectionNameOverrides };

export const sectionOverrides = (roleConfig: Pick<RoleConfig, "sectionNames" | "sectionNamesByLanguage"> | null | undefined): SectionNameOverrides =>
  roleConfig?.sectionNamesByLanguage
    ?? Object.fromEntries(Object.entries(roleConfig?.sectionNames ?? {}).map(([section, name]) => [section, { en: name }]));

export const customSectionName = (overrides: SectionNameOverrides, section: string): string | undefined =>
  overrides[section]?.[currentLanguage()] ?? overrides[section]?.en;

export const displaySectionName = (overrides: SectionNameOverrides, section: SectionKey) =>
  customSectionName(overrides, section) ?? sectionName(section);

const NAV_GROUPS = ["Telemetry", "Blasts", "References", "Targets"] as const;

const isNavGroup = (label: string): label is (typeof NAV_GROUPS)[number] => (NAV_GROUPS as readonly string[]).includes(label);

export const routeLabel = (label: string) => (isNavGroup(label) ? i18n.t(`navGroups.${label}`) : label);

export const roleLabel = (role: { name: string | null; label?: ServerMessage | null }) =>
  role.label ? serverMessage(role.label) : role.name ?? "";
